// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Aliens Configuration - Universe L-Space
 * 
 * Alien species found in the L-Space universe
 */

const LSpaceAliens = [
  {
    id: 'lspace_librarian',
    name: 'Orangutan Librarian',
    description: 'Ook! An orangutan who was once human. Very protective of books.',
    hostility: 0.1,
    commonLocations: [700, 750], // Great Library, Librarian's Outpost
    encounterChance: 0.3,
    rewards: { credits: 500, items: ['Banana', 'Rare Book'] },
  },
  {
    id: 'lspace_bookworm',
    name: 'Metaphorical Bookworm',
    description: 'A literal bookworm that eats through pages. Surprisingly friendly.',
    hostility: 0.2,
    commonLocations: [701, 702, 705],
    encounterChance: 0.4,
    rewards: { credits: 200, items: ['Digested Knowledge'] },
  },
  {
    id: 'lspace_scholar',
    name: 'Eternal Scholar',
    description: 'A being who has been reading for so long they\'ve become part of the library.',
    hostility: 0.0,
    commonLocations: [701, 706, 708],
    encounterChance: 0.25,
    rewards: { credits: 800, items: ['Ancient Wisdom'] },
  },
  {
    id: 'lspace_shadow',
    name: 'Knowledge Shadow',
    description: 'A shadow cast by forbidden knowledge. It knows things you shouldn\'t.',
    hostility: 0.6,
    commonLocations: [703, 707],
    encounterChance: 0.35,
    rewards: { credits: 1000, items: ['Forbidden Tome'] },
  },
];

const LSpaceAliensPlanets = {
  planets: {
    700: ['lspace_librarian'], // Great Library
    701: ['lspace_bookworm', 'lspace_scholar'], // Alexandria Eternal
    702: ['lspace_bookworm'], // Babel Tower
    703: ['lspace_shadow'], // Forbidden Section
    704: [], // Digital Archives (no encounters)
    705: ['lspace_bookworm'], // Unwritten Library
    706: ['lspace_scholar'], // Akashic Records
    707: ['lspace_shadow'], // Burning Library
    708: ['lspace_scholar'], // Memory Palace
    709: ['lspace_bookworm'], // Infinite Bookshelf
    750: ['lspace_librarian'], // Librarian's Outpost
    751: ['lspace_scholar'], // Reader's Rest
    752: ['lspace_bookworm'] // Bookbinder's Workshop
  },
  randomEncounters: ['lspace_bookworm', 'lspace_scholar'],
  hostileSpecies: ['lspace_shadow'],
  friendlyTraders: ['lspace_librarian', 'lspace_scholar']
};

export default LSpaceAliens;
export { LSpaceAliensPlanets };
